export default __webpack_public_path__ + "static/media/xls_white.f8343260.png";